import {
  GET_MUNDIAL_SCHEDULE_RESULTS,
  GET_MUNDIAL_STRUCTURE,
} from '../types/calendar.types';
import { gracenoteApiCall } from './../../api/api';

export const getMundialStructure = () => async dispatch => {
  try {
    const { data } = await gracenoteApiCall({
      url: '/leagues/GNA5MGHG2ZVX2RD/structure',
    });

    dispatch({
      type: GET_MUNDIAL_STRUCTURE,
      payload: data.phases,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getScheduleResults = () => async dispatch => {
  try {
    const [
      { data: firstBlock },
      { data: secondBlock },
      { data: thirdBlock },
    ] = await Promise.all([
      gracenoteApiCall({
        url:
          '/leagues/GNA5MGHG2ZVX2RD/schedule-results?timeFrom=2022-11-20T00:00:00&timeTo=2022-11-30T00:00:00',
      }),
      gracenoteApiCall({
        url:
          '/leagues/GNA5MGHG2ZVX2RD/schedule-results?timeFrom=2022-11-30T00:00:00&timeTo=2022-12-08T00:00:00',
      }),
      gracenoteApiCall({
        url:
          '/leagues/GNA5MGHG2ZVX2RD/schedule-results?timeFrom=2022-12-09T00:00:00&timeTo=2022-12-19T00:00:00',
      }),
    ]);
    dispatch({
      type: GET_MUNDIAL_SCHEDULE_RESULTS,
      payload: [
        ...firstBlock.matches,
        ...secondBlock.matches,
        ...thirdBlock.matches,
      ],
    });
  } catch (error) {
    console.log(error);
  }
};
